import { render, staticRenderFns } from "./Chapter.vue?vue&type=template&id=44cdad0c"
import script from "./Chapter.vue?vue&type=script&lang=js"
export * from "./Chapter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports